export default "__VITE_ASSET__cd4d4521__"